import  { useState, useEffect, useRef, useCallback } from 'react';
import styles from './network-friends.module.css';
import defaultProfile from '../images/default-profile2.jpg';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { sendFriendRequest, acceptFriendRequest, removeFriend } from '../redux/friendSlice';
import { blockUser, unblockUser } from '../redux/blockSlice';
import { getNetworkStatus } from '../redux/friendSlice';
import { useAuth } from '../context/AuthContext';
    

const NetworkFriends = ({initialNetworks,handleProfileClick, onClose}) => {
    const [networkFriends, setNetworkFriends] = useState(initialNetworks || []);
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const itemsPerPage = 10;
    const observetTarget = useRef(null);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const myFriends = useSelector(state => state.friend.projectNetworkList);
    const friendStatuses = useSelector(state => state.friend.friendStatuses);
    // const dataLoaded = useSelector(state => state.friend.dataLoaded);
    const loadingStates = useSelector(state => state.friend.loading);
    const blockedUsers = useSelector(state => state.block.blockedUsers);
    const { userId: currentUserId } = useAuth();

    useEffect(() => {
            const message = localStorage.getItem('notification');
            if (message) {
                setNotification(message);
                localStorage.removeItem('notification');
            }
    }, [navigate]);
    

    const fetchMoreFriends =useCallback( async () => {
        if (loading || !hasMore) return;
        setLoading(true);
        try {
            const response = await fetch(`/api/network-friends?page=${page}&limit=${itemsPerPage}`);
            const data = await response.json();
            if (data.length < itemsPerPage) {
                setHasMore(false);
            }
            setNetworkFriends(prev => [...prev, ...data]);
            setPage(prev => prev + 1);
        }
        catch (error) {
            console.error('Error fetching more friends:', error);
        }
        setLoading(false);
    }, [loading, hasMore, page]);
    // }, [loading, hasMore, fetchMoreFriends]);
    // useEffect(() => {
    //     if (loading) return;
    //     const observer = new IntersectionObserver(entries => {
    //         if (entries[0].isIntersecting && hasMore) {
    //             fetchMoreFriends();
    //         }
    //     }, { threshold: 1.0 });
    //     if (observetTarget.current) {
    //         observer.observe(observetTarget.current);
    //     }
    //     return () => {
    //         if (observetTarget.current) {
    //             observer.unobserve(observetTarget.current);
    //         }
    //     };
    // }, [loading, hasMore, fetchMoreFriends]);

    // const handleConnect = async (event, networkId) => {
    //     event.stopPropagation();
    //     try {
    //         const token = localStorage.getItem('token');
    //         await axios.post('/api/pn/encouraged', { networkId }, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`
    //             }
    //         });
    //         setNotification('Encouragement sent successfully!');
    //         // setEncourageSent([...encourageSent, networkId]);
    //         // setAvailableFreshNetworks(availableFreshNetworks.filter(network => network._id !== networkId));
    //         // setReload(true);
    //     } catch (error) {
    //         console.error('Error sending encouragement:', error);
    //         setNotification('Error sending encouragement. Please try again.');
    // };    }
    
     const handleConnect = async (event, friendId) => {
        event.stopPropagation();
        const result = await dispatch(sendFriendRequest(friendId));
        if (result.success) {
            setNotification('Friend request sent!');
            setTimeout(() => setNotification(''), 3000);
        } else {
            setNotification('Error sending request');
        }
    };


    // Accept handler
    const handleAccept = async (event, friendId) => {
        event.stopPropagation();
        const result = await dispatch(acceptFriendRequest(friendId));
        if (result.success) {
            setNotification('Friend request accepted!');
            setTimeout(() => setNotification(''), 3000);
        } else {
            setNotification(result.error || 'Error accepting request');
            setTimeout(() => setNotification(''), 3000);
        }
    };

    // Remove handler
    const handleRemove = async (event, friendId) => {
        event.stopPropagation();
        const result = await dispatch(removeFriend(friendId));
        if (result.success) {
            setNotification('Friend हटा दिया!');
            setTimeout(() => setNotification(''), 3000);
        } else {
            setNotification(result.error || 'Error removing friend');
            setTimeout(() => setNotification(''), 3000);
        }
    };

    // Block handler
    const handleBlock = async (event, friendId) => {
        event.stopPropagation();
        const result = await dispatch(blockUser(friendId));
        if (result.success) {
            setNotification('User blocked!');
            setTimeout(() => setNotification(''), 3000);
        }else {
            setNotification(result.error || 'Error blocking user');
            setTimeout(() => setNotification(''), 3000);
        }
    };
    // ✅ Unblock करें
    const handleUnblock = async (event, friendId) => {
        event.stopPropagation();
        
        const result = await dispatch(unblockUser(friendId));
        
        if (result.success) {
            setNotification('User unblocked!');
            setTimeout(() => setNotification(''), 3000);
        } else {
            setNotification(result.error || 'Error unblocking user');
            setTimeout(() => setNotification(''), 3000);
        }
    };

    const getActionButton = (friend) => {
        const friendId = friend._id;
        
        // खुद को skip करें
        if (friendId === currentUserId) {
            return <span className={styles.youLabel}></span>;
        }

        const status = friendStatuses[friendId];
        const isBlocked = blockedUsers[friendId];
        const isLoadingAction = loadingStates[friendId];

        // Blocked user
        if (isBlocked) {
            return (
                <button 
                    className={styles.blockedButton}
                    onClick={(e) => {
                        e.stopPropagation();
                        dispatch(unblockUser(friendId));
                    }}
                >
                    Unblock
                </button>
            );
        }
        // Loading state
        if (isLoadingAction) {
            return <button className={styles.loadingButton} disabled>...</button>;
        }

        // ✅ Main status check
        switch (status) {
            case 'friends':
                // पहले से friends हैं
                return (
                    <div className={styles.friendActions}>
                        <span className={styles.friendLabel}>Friends ✓</span>
                        <button 
                            className={styles.secondaryAction}
                            onClick={(e) => handleRemove(e, friendId)}
                        >
                            Remove
                        </button>
                    </div>
                );
            
            case 'sent':
                // Request भेज चुके हैं
                return (
                    <div className={styles.friendActions}>
                        <button className={styles.sentButton} title="Cancel Request"disabled>Request Sent</button>
                    </div>
                );
            
            case 'received':
                // Request आई है
                return (
                    <button 
                        className={styles.acceptButton}
                        onClick={(e) => handleAccept(e, friendId)}
                    >
                        Accept Request
                    </button>
                );
            
            default:
                // कोई relation नहीं है
                return (
                    <button 
                        className={styles.connectButton}
                        onClick={(e) => handleConnect(e, friendId)}
                    >
                        Add Friend
                    </button>
                );
        }
    };

    // ✅ Mutual friends count दिखाएं (optional)
    const getMutualFriendsCount = (friend) => {
        if (!friend.projectNetworkList  || !myFriends) return 0;
        const mutualCount = friend.projectNetworkList.filter(fId => myFriends.includes(fId)).length;
        return mutualCount;
    };
    // const handleProfileClick = (e, networkId) => {
    //     e.stopPropagation();
    //     e.preventDefault();
    //     const profileStatus = friendStatuses[networkId] || 'unknown';
        
    //     console.log("profileStatus:", profileStatus);
        
    //     // Navigate करें status के साथ
    //     navigate(`/profile/${networkId}`
    //         , { state: profileStatus }
    //     );
    // };

    return (
        <>
        <div className={styles.friendsOverlay}>
            <div className={styles.networkFriendsOuter}>
                <div className={styles.networkFriendsContainer}>
                    <button  onClick={onClose} className={styles.closeButton} title='close'>x</button>
                <h2>Friends </h2>
                <div className={styles.friendsList}  onClick={(e) => e.stopPropagation()}>
                    {networkFriends.map((friend, index) => {
                        const mutualCount = getMutualFriendsCount(friend);
                        return (
                        <div key={friend._id} className={styles.friendItem} onClick={(e) => {
                                e.stopPropagation(); // Stop propagation here
                                handleProfileClick(e, friend._id);
                            }}>
                            <img title={friend.name} src={friend?.profilePicture ? friend?.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile} alt={friend.name} className={styles.friendAvatar} />
                            <span className={styles.friendName}>{friend.name}</span>
                            {mutualCount > 0 && (
                                <span className={styles.mutualFriends}>
                                    {mutualCount} mutual friend{mutualCount > 1 ? 's' : ''}
                                </span>
                            )}
                            {/* <button className={styles.connectButton} onClick={handleConnect}>Connect</button> */}
                             {/* Dynamic button */}
                                    {getActionButton(friend)}
                                    
                                    {/* Block option */}
                                    {friend._id !== currentUserId && !blockedUsers[friend._id] && (<></>
                                        // <button 
                                        //     className={styles.blockButton}
                                        //     onClick={(e) => handleBlock(e, friend._id)}
                                        //     title="Block"
                                        // >
                                        //     🚫
                                        
                                        // </button>
                                    )}
                        </div>
                    )})}
                    <div ref={observetTarget} style={{ height: '20px' }}></div>
                    {loading && <p>Loading...</p>}
                    {!hasMore && <p>No more friends to load.</p>}
                </div>
                </div>  
            </div>
        </div>
        </>
    );
}

export default NetworkFriends;